'use client'

import { cn } from '@/lib/utils'

type DepositOptionProps = {
	icon: React.ReactNode
	title: string
	description: string
	disabled?: boolean
	onClick?: () => void
	logoSrc?: string
}

export function DepositOption({
	icon,
	title,
	description,
	disabled = false,
	onClick,
	logoSrc,
}: DepositOptionProps) {
	return (
		<button
			type="button"
			onClick={onClick}
			disabled={disabled}
			className={cn(
				'w-full cursor-pointer rounded-[12px] border border-brand-gray bg-brand-dark-light p-[24px]',
				disabled && 'cursor-not-allowed opacity-50'
			)}
		>
			<div className="flex items-center gap-4">
				<div className="shrink-0 text-muted-foreground">{icon}</div>
				<div className="flex flex-col gap-[8px]">
					<div className="flex items-center gap-2">
						<h3 className="text-left font-semibold text-[16px] text-white leading-[100%]">
							{title}
						</h3>
						{logoSrc && (
							<img
								src={logoSrc}
								alt=""
								className="h-5 max-w-[70px] object-contain object-left lg:max-w-[120px]"
							/>
						)}
					</div>
					<p className="text-left text-[16px] text-brand-gray-secondary leading-[100%]">
						{description}
					</p>
				</div>
			</div>
		</button>
	)
}
